import React, { FC } from 'react';
import { SVG } from "./SVG";

export const CameraPickOff: FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <SVG {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" isIcon>
        <path d="M22.7 18.5C22.8 18.5 22.9 18.4 22.9 18.3C22.9 18.2 23 18.1 23 18V6C23 5.9 23 5.8 22.9 5.7C22.9 5.6 22.8 5.6 22.7 5.5C22.6 5.5 22.5 5.4 22.4 5.4C22.3 5.4 22.2 5.4 22.1 5.5L17 9.2V5C17 4.7 16.9 4.5 16.7 4.3C16.5 4.1 16.3 4 16 4H8.19995L22.7 18.5Z"/>
        <path d="M22.2 20.8L21.8 20.4L17 15.6L5.4 4L2.4 1L1 2.4L2.6 4H2C1.7 4 1.5 4.1 1.3 4.3C1.1 4.5 1 4.7 1 5V19C1 19.3 1.1 19.5 1.3 19.7C1.5 19.9 1.7 20 2 20H16C16.3 20 16.5 19.9 16.7 19.7C16.9 19.5 17 19.3 17 19V18.4L20.8 22.2L22.2 20.8Z" />
    </SVG>
);